import { FormEvent, useEffect, useState } from "react";
import { Button, Col, Form, Row, ToggleButton } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineCheckBoxInput, defineValueInInput, getValueFromInput, showInputErrorMsg } from "../../../../components/funcForInput";
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros";
import funcSleep from "../../../../components/funcSleep";
import LoadingModal from "../../../../components/loadingModal";
import { ApiEndpoints, reqPatch, reqPut } from "../../../../config/apiClient";
import stylesCheckbox from "../../../colaborador/styles/colaborador.module.css";

export default function EscalaNormalForm({ escala, handleUpdate }: iProps) {
    useEffect(() => {
        if (Object.values(escala).length > 0) {
            carregarDados(escala);
        }
    }, [escala]);

    const [loading, setLoading] = useState<boolean>(false);

    const [diaSegunda, setDiaSegunda] = useState<boolean>(false);
    const [diaTerca, setDiaTerca] = useState<boolean>(false);
    const [diaQuarta, setDiaQuarta] = useState<boolean>(false);
    const [diaQuinta, setDiaQuinta] = useState<boolean>(false);
    const [diaSexta, setDiaSexta] = useState<boolean>(false);
    const [diaSabado, setDiaSabado] = useState<boolean>(false);
    const [diaDomingo, setDiaDomingo] = useState<boolean>(false);

    const [registrarIntervalo, setRegistrarIntervalo] = useState<boolean>(true);
    const [calcularHorarioNoturno, setCalcularHorarioNoturno] = useState<number>(0);

    function carregarDados(escala: any) {
        // defineCheckBoxInput("registrar_intervalo",)
        setRegistrarIntervalo(escala.intervalo_registrar === 1 ? true : false);
        defineCheckBoxInput("escala_banco_horas", escala.escala_banco_horas === 1 ? true : false);

        defineValueInInput("tolerancia_maxima", escala.tempo_maximo_diario_tolerancia);
        defineValueInInput("tolerancia_entrada_extra", escala.tolerancia_extra_entrada);
        defineValueInInput("tolerancia_entrada_atraso", escala.tolerancia_atraso_entrada);
        defineValueInInput("tolerancia_saida_extra", escala.tolerancia_extra_saida);
        defineValueInInput("tolerancia_saida_atraso", escala.tolerancia_atraso_saida);

        if (escala.segunda === 1) {
            setDiaSegunda(true);
        }
        if (escala.terca === 1) {
            setDiaTerca(true);
        }
        if (escala.quarta === 1) {
            setDiaQuarta(true);
        }
        if (escala.quinta === 1) {
            setDiaQuinta(true);
        }
        if (escala.sexta === 1) {
            setDiaSexta(true);
        }
        if (escala.sabado === 1) {
            setDiaSabado(true);
        }
        if (escala.domingo === 1) {
            setDiaDomingo(true);
        }

        for (let idx = 0; idx < 7; idx++) {
            let dia_semana = DIAS_SEMANA[idx];
            if (escala[dia_semana] === 0) {
                continue;
            }

            defineValueInInput(`${dia_semana}_horario_entrada`, escala[`${dia_semana}_entrada`]);
            defineValueInInput(`${dia_semana}_horario_saida`, escala[`${dia_semana}_saida`]);
            if (escala.intervalo_registrar === 1) {
                defineValueInInput(`${dia_semana}_intervalo_entrada`, escala[`${dia_semana}_intervalo_entrada`]);
                defineValueInInput(`${dia_semana}_intervalo_saida`, escala[`${dia_semana}_intervalo_saida`]);
            }

            defineCheckBoxInput(`${dia_semana}_calcular_horas`, escala[`${dia_semana}_calcular_horas`] === 1 ? true : false);
            defineCheckBoxInput(`${dia_semana}_gerar_ocorrencia`, escala[`${dia_semana}_gerar_ocorrencias`] === 1 ? true : false);
            defineCheckBoxInput(`${dia_semana}_dia_flexivel`, escala[`${dia_semana}_escala_flexivel`] === 1 ? true : false);
        }

        // defineValueInInput("horario_noturno", )
        setCalcularHorarioNoturno(escala.horario_noturno);
        if (escala.horario_noturno === 1) {
            defineValueInInput("noturno_inicio", escala.noturno_inicio);
            defineValueInInput("noturno_fim", escala.noturno_fim);
        }
        defineValueInInput("horario_noturno_prorrogado", escala.noturno_prorrogado);
    }

    async function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        event.stopPropagation();
        removeAllErrorMsg();

        const form: any = event.target;
        let formValidado = true;
        let dados = {
            id_escala: Object.values(escala).length === 0 ? null : escala.id_escala,
            codigo: Number(getValueFromInput("codigo")),
            descricao: getValueFromInput("descricao"),
            id_tipo: 1,
            escala_sdf: 0,
            tipo_diurna_noturna: 0,
            atualizada: 1,
            data_base: "2022-05-01",
            escala_base: null,
            escala_banco_horas: form.escala_banco_horas.checked === true ? 1 : 0,
            segunda: diaSegunda === true ? 1 : 0,
            segunda_escala_flexivel: form.segunda_dia_flexivel.checked === true ? 1 : 0,
            segunda_gerar_ocorrencias: form.segunda_gerar_ocorrencia.checked === true ? 1 : 0,
            segunda_calcular_horas: form.segunda_calcular_horas.checked === true ? 1 : 0,
            segunda_entrada: form.segunda_horario_entrada.value,
            segunda_saida: form.segunda_horario_saida.value,
            segunda_intervalo_entrada: form.segunda_intervalo_entrada.value,
            segunda_intervalo_saida: form.segunda_intervalo_saida.value,
            terca: diaTerca === true ? 1 : 0,
            terca_escala_flexivel: form.terca_dia_flexivel.checked === true ? 1 : 0,
            terca_gerar_ocorrencias: form.terca_gerar_ocorrencia.checked === true ? 1 : 0,
            terca_calcular_horas: form.terca_calcular_horas.checked === true ? 1 : 0,
            terca_entrada: form.terca_horario_entrada.value,
            terca_saida: form.terca_horario_saida.value,
            terca_intervalo_entrada: form.terca_intervalo_entrada.value,
            terca_intervalo_saida: form.terca_intervalo_saida.value,
            quarta: diaQuarta === true ? 1 : 0,
            quarta_escala_flexivel: form.quarta_dia_flexivel.checked === true ? 1 : 0,
            quarta_gerar_ocorrencias: form.quarta_gerar_ocorrencia.checked === true ? 1 : 0,
            quarta_calcular_horas: form.quarta_calcular_horas.checked === true ? 1 : 0,
            quarta_entrada: form.quarta_horario_entrada.value,
            quarta_saida: form.quarta_horario_saida.value,
            quarta_intervalo_entrada: form.quarta_intervalo_entrada.value,
            quarta_intervalo_saida: form.quarta_intervalo_saida.value,
            quinta: diaQuinta === true ? 1 : 0,
            quinta_escala_flexivel: form.quinta_dia_flexivel.checked === true ? 1 : 0,
            quinta_gerar_ocorrencias: form.quinta_gerar_ocorrencia.checked === true ? 1 : 0,
            quinta_calcular_horas: form.quinta_calcular_horas.checked === true ? 1 : 0,
            quinta_entrada: form.quinta_horario_entrada.value,
            quinta_saida: form.quinta_horario_saida.value,
            quinta_intervalo_entrada: form.quinta_intervalo_entrada.value,
            quinta_intervalo_saida: form.quinta_intervalo_saida.value,
            sexta: diaSexta === true ? 1 : 0,
            sexta_escala_flexivel: form.sexta_dia_flexivel.checked === true ? 1 : 0,
            sexta_gerar_ocorrencias: form.sexta_gerar_ocorrencia.checked === true ? 1 : 0,
            sexta_calcular_horas: form.sexta_calcular_horas.checked === true ? 1 : 0,
            sexta_entrada: form.sexta_horario_entrada.value,
            sexta_saida: form.sexta_horario_saida.value,
            sexta_intervalo_entrada: form.sexta_intervalo_entrada.value,
            sexta_intervalo_saida: form.sexta_intervalo_saida.value,
            sabado: diaSabado === true ? 1 : 0,
            sabado_escala_flexivel: form.sabado_dia_flexivel.checked === true ? 1 : 0,
            sabado_gerar_ocorrencias: form.sabado_gerar_ocorrencia.checked === true ? 1 : 0,
            sabado_calcular_horas: form.sabado_calcular_horas.checked === true ? 1 : 0,
            sabado_entrada: form.sabado_horario_entrada.value,
            sabado_saida: form.sabado_horario_saida.value,
            sabado_intervalo_entrada: form.sabado_intervalo_entrada.value,
            sabado_intervalo_saida: form.sabado_intervalo_saida.value,
            domingo: diaDomingo === true ? 1 : 0,
            domingo_escala_flexivel: form.domingo_dia_flexivel.checked === true ? 1 : 0,
            domingo_gerar_ocorrencias: form.domingo_gerar_ocorrencia.checked === true ? 1 : 0,
            domingo_calcular_horas: form.domingo_calcular_horas.checked === true ? 1 : 0,
            domingo_entrada: form.domingo_horario_entrada.value,
            domingo_saida: form.domingo_horario_saida.value,
            domingo_intervalo_entrada: form.domingo_intervalo_entrada.value,
            domingo_intervalo_saida: form.domingo_intervalo_saida.value,
            horario_entrada: null,
            intervalo_entrada: null,
            intervalo_saida: null,
            horario_saida: null,
            intervalo_registrar: form.registrar_intervalo.checked === true ? 1 : 0,
            tempo_maximo_diario_tolerancia: Number(form.tolerancia_maxima.value),
            tolerancia_extra_entrada: Number(form.tolerancia_entrada_extra.value),
            tolerancia_atraso_entrada: Number(form.tolerancia_entrada_atraso.value),
            tolerancia_extra_saida: Number(form.tolerancia_saida_extra.value),
            tolerancia_atraso_saida: Number(form.tolerancia_saida_atraso.value),
            horario_noturno: Number(form.horario_noturno.value),
            noturno_inicio: form.noturno_inicio.value,
            noturno_fim: form.noturno_fim.value,
            noturno_prorrogado: Number(form.horario_noturno_prorrogado.value),
        };

        // Validação Identificação
        if (dados.codigo === 0) {
            showInputErrorMsg("codigo");
            // form.codigo.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.descricao === "") {
            showInputErrorMsg("descricao");
            // form.descricao.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        // Validação Dias da Semana
        let selecionar_horarios = diaSegunda || diaTerca || diaQuarta || diaQuinta || diaSexta || diaSabado || diaDomingo;
        if (!selecionar_horarios) {
            formValidado = false;
            toast.warning("Necessário selecionar 1 dia!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }

        let horarios_validacao = handleValidarHorarios(dados, form);
        let horarios_preenchidos = horarios_validacao.horarios_preenchidos;
        dados = horarios_validacao.dados;
        if (!horarios_preenchidos) {
            formValidado = false;
            toast.warning("Necessário informar todos os horários!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }

        // Validação Tempo de Tolerância
        if (dados.tempo_maximo_diario_tolerancia === 0) {
            form.tolerancia_maxima.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_extra_entrada === 0) {
            form.tolerancia_entrada_extra.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_extra_saida === 0) {
            form.tolerancia_saida_extra.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_atraso_entrada === 0) {
            form.tolerancia_entrada_atraso.nextElementSibling.style.display = "block";
            formValidado = false;
        }
        if (dados.tolerancia_atraso_saida === 0) {
            form.tolerancia_saida_atraso.nextElementSibling.style.display = "block";
            formValidado = false;
        }

        // Validação Adicionar Noturno
        if (dados.horario_noturno === 1) {
            if (dados.noturno_inicio === "") {
                form.noturno_inicio.nextElementSibling.style.display = "block";
                formValidado = false;
            }
            if (dados.noturno_fim === "") {
                form.noturno_fim.nextElementSibling.style.display = "block";
                formValidado = false;
            }
        }
        if (dados.horario_noturno === 0) {
            dados.noturno_inicio = null;
            dados.noturno_fim = null;
        }

        console.log(dados);
        if (!formValidado) {
            return;
        }

        if (dados.id_escala === null) {
            await cadastrar(dados);
        }
        if (dados.id_escala > 0) {
            await editar(dados);
        }
    }

    function handleValidarHorarios(dados: any, form: any) {
        let horarios_preenchidos = true;

        if (dados.segunda === 1) {
            if (dados.segunda_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.segunda_saida === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_registrar === 1) {
                if (dados.segunda_intervalo_entrada === "") {
                    horarios_preenchidos = false;
                }
                if (dados.segunda_intervalo_saida === "") {
                    horarios_preenchidos = false;
                }
            } else {
                dados.segunda_intervalo_entrada = null;
                dados.segunda_intervalo_saida = null;
            }
        } else {
            dados.segunda_entrada = null;
            dados.segunda_saida = null;
            dados.segunda_intervalo_entrada = null;
            dados.segunda_intervalo_saida = null;
            dados.segunda_escala_flexivel = null;
            dados.segunda_gerar_ocorrencias = null;
            dados.segunda_calcular_horas = null;
        }

        if (dados.terca === 1) {
            if (dados.terca_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.terca_saida === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_registrar === 1) {
                if (dados.terca_intervalo_entrada === "") {
                    horarios_preenchidos = false;
                }
                if (dados.terca_intervalo_saida === "") {
                    horarios_preenchidos = false;
                }
            } else {
                dados.terca_intervalo_entrada = null;
                dados.terca_intervalo_saida = null;
            }
        } else {
            dados.terca_entrada = null;
            dados.terca_saida = null;
            dados.terca_intervalo_entrada = null;
            dados.terca_intervalo_saida = null;
            dados.terca_escala_flexivel = null;
            dados.terca_gerar_ocorrencias = null;
            dados.terca_calcular_horas = null;
        }

        if (dados.quarta === 1) {
            if (dados.quarta_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.quarta_saida === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_registrar === 1) {
                if (dados.quarta_intervalo_entrada === "") {
                    horarios_preenchidos = false;
                }
                if (dados.quarta_intervalo_saida === "") {
                    horarios_preenchidos = false;
                }
            } else {
                dados.quarta_intervalo_entrada = null;
                dados.quarta_intervalo_saida = null;
            }
        } else {
            dados.quarta_entrada = null;
            dados.quarta_saida = null;
            dados.quarta_intervalo_entrada = null;
            dados.quarta_intervalo_saida = null;
            dados.quarta_escala_flexivel = null;
            dados.quarta_gerar_ocorrencias = null;
            dados.quarta_calcular_horas = null;
        }

        if (dados.quinta === 1) {
            if (dados.quinta_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.quinta_saida === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_registrar === 1) {
                if (dados.quinta_intervalo_entrada === "") {
                    horarios_preenchidos = false;
                }
                if (dados.quinta_intervalo_saida === "") {
                    horarios_preenchidos = false;
                }
            } else {
                dados.quinta_intervalo_entrada = null;
                dados.quinta_intervalo_saida = null;
            }
        } else {
            dados.quinta_entrada = null;
            dados.quinta_saida = null;
            dados.quinta_intervalo_entrada = null;
            dados.quinta_intervalo_saida = null;
            dados.quinta_escala_flexivel = null;
            dados.quinta_gerar_ocorrencias = null;
            dados.quinta_calcular_horas = null;
        }

        if (dados.sexta === 1) {
            if (dados.sexta_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.sexta_saida === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_registrar === 1) {
                if (dados.sexta_intervalo_entrada === "") {
                    horarios_preenchidos = false;
                }
                if (dados.sexta_intervalo_saida === "") {
                    horarios_preenchidos = false;
                }
            } else {
                dados.sexta_intervalo_entrada = null;
                dados.sexta_intervalo_saida = null;
            }
        } else {
            dados.sexta_entrada = null;
            dados.sexta_saida = null;
            dados.sexta_intervalo_entrada = null;
            dados.sexta_intervalo_saida = null;
            dados.sexta_escala_flexivel = null;
            dados.sexta_gerar_ocorrencias = null;
            dados.sexta_calcular_horas = null;
        }

        if (dados.sabado === 1) {
            if (dados.sabado_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.sabado_saida === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_registrar === 1) {
                if (dados.sabado_intervalo_entrada === "") {
                    horarios_preenchidos = false;
                }
                if (dados.sabado_intervalo_saida === "") {
                    horarios_preenchidos = false;
                }
            } else {
                dados.sabado_intervalo_entrada = null;
                dados.sabado_intervalo_saida = null;
            }
        } else {
            dados.sabado_entrada = null;
            dados.sabado_saida = null;
            dados.sabado_intervalo_entrada = null;
            dados.sabado_intervalo_saida = null;
            dados.sabado_escala_flexivel = null;
            dados.sabado_gerar_ocorrencias = null;
            dados.sabado_calcular_horas = null;
        }

        if (dados.domingo === 1) {
            if (dados.domingo_entrada === "") {
                horarios_preenchidos = false;
            }
            if (dados.domingo_saida === "") {
                horarios_preenchidos = false;
            }
            if (dados.intervalo_registrar === 1) {
                if (dados.domingo_intervalo_entrada === "") {
                    horarios_preenchidos = false;
                }
                if (dados.domingo_intervalo_saida === "") {
                    horarios_preenchidos = false;
                }
            } else {
                dados.domingo_intervalo_entrada = null;
                dados.domingo_intervalo_saida = null;
            }
        } else {
            dados.domingo_entrada = null;
            dados.domingo_saida = null;
            dados.domingo_intervalo_entrada = null;
            dados.domingo_intervalo_saida = null;
            dados.domingo_escala_flexivel = null;
            dados.domingo_gerar_ocorrencias = null;
            dados.domingo_calcular_horas = null;
        }

        return { horarios_preenchidos, dados };
    }

    function handleChangeHorarioNoturno(event: any) {
        const calcular_noturno = Number(event.target.value);
        setCalcularHorarioNoturno(calcular_noturno);
    }

    function handleCopyHorarios(dia: string) {
        let entrada = getValueFromInput(`${dia}_horario_entrada`);
        let saida = getValueFromInput(`${dia}_horario_saida`);
        let intervalo_entrada = registrarIntervalo === false ? "" : getValueFromInput(`${dia}_intervalo_entrada`);
        let intervalo_saida = registrarIntervalo === false ? "" : getValueFromInput(`${dia}_intervalo_saida`);

        for (let idx = 0; idx < 7; idx++) {
            let dia_semana = DIAS_SEMANA[idx];
            if (dia === dia_semana) {
                continue;
            }
            if (dia_semana === "segunda" && !diaSegunda) {
                continue;
            }
            if (dia_semana === "terca" && !diaTerca) {
                continue;
            }
            if (dia_semana === "quarta" && !diaQuarta) {
                continue;
            }
            if (dia_semana === "quinta" && !diaQuinta) {
                continue;
            }
            if (dia_semana === "sexta" && !diaSexta) {
                continue;
            }
            if (dia_semana === "sabado" && !diaSabado) {
                continue;
            }
            if (dia_semana === "domingo" && !diaDomingo) {
                continue;
            }

            defineValueInInput(`${dia_semana}_horario_entrada`, entrada);
            defineValueInInput(`${dia_semana}_horario_saida`, saida);
            if (registrarIntervalo) {
                defineValueInInput(`${dia_semana}_intervalo_entrada`, intervalo_entrada);
                defineValueInInput(`${dia_semana}_intervalo_saida`, intervalo_saida);
            }
        }
    }

    function handleClearHorarios() {
        for (let idx = 0; idx < 7; idx++) {
            let dia_semana = DIAS_SEMANA[idx];
            if (dia_semana === "segunda" && !diaSegunda) {
                continue;
            }
            if (dia_semana === "terca" && !diaTerca) {
                continue;
            }
            if (dia_semana === "quarta" && !diaQuarta) {
                continue;
            }
            if (dia_semana === "quinta" && !diaQuinta) {
                continue;
            }
            if (dia_semana === "sexta" && !diaSexta) {
                continue;
            }
            if (dia_semana === "sabado" && !diaSabado) {
                continue;
            }
            if (dia_semana === "domingo" && !diaDomingo) {
                continue;
            }

            defineValueInInput(`${dia_semana}_horario_entrada`, "");
            defineValueInInput(`${dia_semana}_horario_saida`, "");
            if (registrarIntervalo) {
                defineValueInInput(`${dia_semana}_intervalo_entrada`, "");
                defineValueInInput(`${dia_semana}_intervalo_saida`, "");
            }
        }
    }

    async function cadastrar(dados: any) {
        setLoading(true);
        const api = await reqPut(ApiEndpoints.pontoEscalaCadastrar, dados);
        if (api.status === 201) {
            toast.success("Escala cadastrada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            window.location.assign(`/ponto/escalas`);
        } else {
            setLoading(false);
        }
    }

    async function editar(dados: any) {
        setLoading(true);
        const api = await reqPatch(ApiEndpoints.pontoEscalaEditar, dados);
        if (api.status === 200) {
            toast.success("Escala editada com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await funcSleep(600);
            window.location.assign(`/ponto/escalas`);
        } else {
            setLoading(false);
        }
    }

    return (
        <div>
            <LoadingModal show={loading} handleClose={() => setLoading(false)} />
            <Form id="formEscalaNormal" onSubmit={handleSubmit} style={{ position: "relative" }} noValidate>
                <div className="mb-15-forms">
                    <div className="col-12">
                        <Form.Group>
                            <Form.Label>Dias da Semana:</Form.Label>
                            <div>
                                <ToggleButton style={styleForDiasSemana} id="segunda" value="segunda" type="checkbox" variant="outline-primary" checked={diaSegunda} defaultChecked={diaSegunda} onChange={(e) => setDiaSegunda(e.currentTarget.checked)}>
                                    Segunda
                                </ToggleButton>
                                <ToggleButton style={styleForDiasSemana} id="terca" value="terca" type="checkbox" variant="outline-primary" checked={diaTerca} defaultChecked={diaTerca} onChange={(e) => setDiaTerca(e.currentTarget.checked)}>
                                    Terça
                                </ToggleButton>
                                <ToggleButton style={styleForDiasSemana} id="quarta" value="quarta" type="checkbox" variant="outline-primary" checked={diaQuarta} defaultChecked={diaQuarta} onChange={(e) => setDiaQuarta(e.currentTarget.checked)}>
                                    Quarta
                                </ToggleButton>
                                <ToggleButton style={styleForDiasSemana} id="quinta" value="quinta" type="checkbox" variant="outline-primary" checked={diaQuinta} defaultChecked={diaQuinta} onChange={(e) => setDiaQuinta(e.currentTarget.checked)}>
                                    Quinta
                                </ToggleButton>
                                <ToggleButton style={styleForDiasSemana} id="sexta" value="sexta" type="checkbox" variant="outline-primary" checked={diaSexta} defaultChecked={diaSexta} onChange={(e) => setDiaSexta(e.currentTarget.checked)}>
                                    Sexta
                                </ToggleButton>
                                <ToggleButton style={styleForDiasSemana} id="sabado" value="sabado" type="checkbox" variant="outline-primary" checked={diaSabado} defaultChecked={diaSabado} onChange={(e) => setDiaSabado(e.currentTarget.checked)}>
                                    Sabado
                                </ToggleButton>
                                <ToggleButton style={styleForDiasSemana} id="domingo" value="domingo" type="checkbox" variant="outline-primary" checked={diaDomingo} defaultChecked={diaDomingo} onChange={(e) => setDiaDomingo(e.currentTarget.checked)}>
                                    Domingo
                                </ToggleButton>
                            </div>
                            <Form.Control.Feedback type="invalid">Selecione um dia na semana!</Form.Control.Feedback>
                        </Form.Group>
                    </div>
                </div>

                <div className="mb-15-forms">
                    <div className="col-4">
                        <Form.Group>
                            <Form.Label>Informe os horários da Escala:</Form.Label>
                            <Form.Check type="switch" id="registrar_intervalo" label="Necessário registrar o intervalo" checked={registrarIntervalo} className={stylesCheckbox.inputCheck} onChange={(e) => setRegistrarIntervalo(e.currentTarget.checked)} />
                            <Form.Check type="switch" id="escala_banco_horas" label="Escala com Banco de Horas" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                        </Form.Group>
                    </div>
                </div>

                <div className="mb-15-forms" style={{ width: "100%", overflowX: "auto" }}>
                    <div className="div-row" style={{ width: "max-content" }}>
                        <div className="card" id="card-segunda" style={{ width: "18rem", display: diaSegunda ? "block" : "none", marginRight: "10px" }}>
                            <div className="card-header div-row-space-between">
                                <p>Segunda</p>
                                <div className="div-row">
                                    <span style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleClearHorarios()} className="material-symbols-outlined">
                                        clear_all
                                    </span>
                                    <span style={{ cursor: "pointer" }} onClick={() => handleCopyHorarios("segunda")} className="material-symbols-outlined">
                                        content_copy
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="segunda_horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="segunda_horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="segunda_intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="segunda_intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>
                                </div>

                                <Form.Check type="switch" id="segunda_dia_flexivel" label="Dia Flexível?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="segunda_gerar_ocorrencia" label="Gerar Ocorrência?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="segunda_calcular_horas" label="Calcular Horas?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                            </div>
                        </div>
                        <div className="card" id="card-terca" style={{ width: "18rem", display: diaTerca ? "block" : "none", marginRight: "10px" }}>
                            <div className="card-header div-row-space-between">
                                <p>Terça</p>
                                <div className="div-row">
                                    <span style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleClearHorarios()} className="material-symbols-outlined">
                                        clear_all
                                    </span>
                                    <span style={{ cursor: "pointer" }} onClick={() => handleCopyHorarios("terca")} className="material-symbols-outlined">
                                        content_copy
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="terca_horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="terca_horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="terca_intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="terca_intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>
                                </div>

                                <Form.Check type="switch" id="terca_dia_flexivel" label="Dia Flexível?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="terca_gerar_ocorrencia" label="Gerar Ocorrência?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="terca_calcular_horas" label="Calcular Horas?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                            </div>
                        </div>
                        <div className="card" id="card-quarta" style={{ width: "18rem", display: diaQuarta ? "block" : "none", marginRight: "10px" }}>
                            <div className="card-header div-row-space-between">
                                <p>Quarta</p>
                                <div className="div-row">
                                    <span style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleClearHorarios()} className="material-symbols-outlined">
                                        clear_all
                                    </span>
                                    <span style={{ cursor: "pointer" }} onClick={() => handleCopyHorarios("quarta")} className="material-symbols-outlined">
                                        content_copy
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="quarta_horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="quarta_horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="quarta_intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="quarta_intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>
                                </div>

                                <Form.Check type="switch" id="quarta_dia_flexivel" label="Dia Flexível?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="quarta_gerar_ocorrencia" label="Gerar Ocorrência?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="quarta_calcular_horas" label="Calcular Horas?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                            </div>
                        </div>
                        <div className="card" id="card-quinta" style={{ width: "18rem", display: diaQuinta ? "block" : "none", marginRight: "10px" }}>
                            <div className="card-header div-row-space-between">
                                <p>Quinta</p>
                                <div className="div-row">
                                    <span style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleClearHorarios()} className="material-symbols-outlined">
                                        clear_all
                                    </span>
                                    <span style={{ cursor: "pointer" }} onClick={() => handleCopyHorarios("quinta")} className="material-symbols-outlined">
                                        content_copy
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="quinta_horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="quinta_horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="quinta_intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="quinta_intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>
                                </div>

                                <Form.Check type="switch" id="quinta_dia_flexivel" label="Dia Flexível?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="quinta_gerar_ocorrencia" label="Gerar Ocorrência?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="quinta_calcular_horas" label="Calcular Horas?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                            </div>
                        </div>
                        <div className="card" id="card-sexta" style={{ width: "18rem", display: diaSexta ? "block" : "none", marginRight: "10px" }}>
                            <div className="card-header div-row-space-between">
                                <p>Sexta</p>
                                <div className="div-row">
                                    <span style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleClearHorarios()} className="material-symbols-outlined">
                                        clear_all
                                    </span>
                                    <span style={{ cursor: "pointer" }} onClick={() => handleCopyHorarios("sexta")} className="material-symbols-outlined">
                                        content_copy
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="sexta_horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="sexta_horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="sexta_intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="sexta_intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>
                                </div>

                                <Form.Check type="switch" id="sexta_dia_flexivel" label="Dia Flexível?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="sexta_gerar_ocorrencia" label="Gerar Ocorrência?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="sexta_calcular_horas" label="Calcular Horas?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                            </div>
                        </div>
                        <div className="card" id="card-sabado" style={{ width: "18rem", display: diaSabado ? "block" : "none", marginRight: "10px" }}>
                            <div className="card-header div-row-space-between">
                                <p>Sabado</p>
                                <div className="div-row">
                                    <span style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleClearHorarios()} className="material-symbols-outlined">
                                        clear_all
                                    </span>
                                    <span style={{ cursor: "pointer" }} onClick={() => handleCopyHorarios("sabado")} className="material-symbols-outlined">
                                        content_copy
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="sabado_horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="sabado_horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="sabado_intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="sabado_intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>
                                </div>

                                <Form.Check type="switch" id="sabado_dia_flexivel" label="Dia Flexível?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="sabado_gerar_ocorrencia" label="Gerar Ocorrência?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="sabado_calcular_horas" label="Calcular Horas?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                            </div>
                        </div>
                        <div className="card" id="card-domingo" style={{ width: "18rem", display: diaDomingo ? "block" : "none", marginRight: "10px" }}>
                            <div className="card-header div-row-space-between">
                                <p>Domingo</p>
                                <div className="div-row">
                                    <span style={{ cursor: "pointer", marginRight: "10px" }} onClick={() => handleClearHorarios()} className="material-symbols-outlined">
                                        clear_all
                                    </span>
                                    <span style={{ cursor: "pointer" }} onClick={() => handleCopyHorarios("domingo")} className="material-symbols-outlined">
                                        content_copy
                                    </span>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Entrada
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-entrada" aria-describedby="addon-wrapping" id="domingo_horario_entrada" autoComplete="off" placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                        Saída
                                    </span>
                                    <Form.Control type="time" className="form-control horarios" aria-label="horario-saida" aria-describedby="addon-wrapping" id="domingo_horario_saida" autoComplete={"off"} placeholder="HH:mm" />
                                </div>
                                <br></br>

                                <div style={{ display: registrarIntervalo ? "block" : "none" }}>
                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Início Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-entrada" aria-describedby="addon-wrapping" id="domingo_intervalo_entrada" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>

                                    <div className="input-group flex-nowrap input-intervalo">
                                        <span className="input-group-text" id="addon-wrapping" style={{ width: "131px" }}>
                                            Fim Intervalo
                                        </span>
                                        <Form.Control type="time" className="form-control horarios" aria-label="intervalo-saida" aria-describedby="addon-wrapping" id="domingo_intervalo_saida" autoComplete="off" placeholder="HH:mm" />
                                    </div>
                                    <br></br>
                                </div>

                                <Form.Check type="switch" id="domingo_dia_flexivel" label="Dia Flexível?" defaultChecked={false} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="domingo_gerar_ocorrencia" label="Gerar Ocorrência?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                                <Form.Check type="switch" id="domingo_calcular_horas" label="Calcular Horas?" defaultChecked={true} className={stylesCheckbox.inputCheck} />
                            </div>
                        </div>
                    </div>
                </div>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tempo máximo diário de tolerância (minutos):</Form.Label>
                            <Form.Control name="tolerancia_maxima" type="number" id="tolerancia_maxima" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância diário!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Extra de Entrada (minutos):</Form.Label>
                            <Form.Control name="tolerancia_entrada_extra" type="number" id="tolerancia_entrada_extra" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância extra entrada!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Atraso de Entrada (minutos):</Form.Label>
                            <Form.Control name="tolerancia_entrada_atraso" type="number" id="tolerancia_entrada_atraso" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância atraso entrada!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Extra de Saída (minutos):</Form.Label>
                            <Form.Control name="tolerancia_saida_extra" type="number" id="tolerancia_saida_extra" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância extra saída!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Group>
                            <Form.Label>Tolerância Atraso de Saída (minutos):</Form.Label>
                            <Form.Control name="tolerancia_saida_atraso" type="number" id="tolerancia_saida_atraso" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe a tolerância atraso saída!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-15-forms">
                    <Col className="col-3">
                        <Form.Label>Calcular adicional noturno?</Form.Label>
                        <Form.Select aria-label="Calcular adicional noturno?" value={calcularHorarioNoturno} onChange={(e) => handleChangeHorarioNoturno(e)} id="horario_noturno">
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </Form.Select>
                    </Col>
                    <Col className="col-3" style={{ display: calcularHorarioNoturno === 1 ? "block" : "none" }}>
                        <Form.Group>
                            <Form.Label>Horário Noturno Início:</Form.Label>
                            <Form.Control name="noturno_inicio" type="time" id="noturno_inicio" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe o horário de início!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3" style={{ display: calcularHorarioNoturno === 1 ? "block" : "none" }}>
                        <Form.Group>
                            <Form.Label>Horário Noturno Fim:</Form.Label>
                            <Form.Control name="noturno_fim" type="time" id="noturno_fim" placeholder="" />
                            <Form.Control.Feedback type="invalid">Informe o horário de fim!</Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col className="col-3">
                        <Form.Label>Horário Noturno Prorrogado?</Form.Label>
                        <Form.Select aria-label="Horário Noturno Prorrogado?" id="horario_noturno_prorrogado">
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                        </Form.Select>
                    </Col>
                </Row>

                <Button variant="success" type="submit">
                    Salvar Escala
                </Button>
            </Form>
        </div>
    );
}
interface iProps {
    escala: any;
    handleUpdate: any;
}

let styleForDiasSemana: React.CSSProperties = {
    width: "100px",
    marginRight: "5px",
    marginBottom: "2px",
};

const DIAS_SEMANA: string[] = ["segunda", "terca", "quarta", "quinta", "sexta", "sabado", "domingo"];
